import { Historic } from './historic.model';

export class HistoricResponse {
  historicList: Historic[];
  total: number;

  constructor(historicList: any, total: number) {
    this.historicList = historicList;
    this.total = total;
  }
}
